import OnboardingAI from './OnboardingAI'

export default OnboardingAI
// eslint-disable-next-line import/export
export * from './OnboardingAI'
